module.exports = __webpack_public_path__ + "static/media/ROBO.48579171.avif";